import { AbstractHook } from '@hooks/abstraction';
import { DefaultColumnResponse } from '../services/responses/default-columns.response';
import { DefaultColumnService } from '../services/default-columns.service';

export class DefaultColumnHook extends AbstractHook<DefaultColumnResponse, DefaultColumnService> {}
